import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';

// Reactstrap components
import { Button, Card, CardHeader, CardBody, CardFooter, FormGroup, Input, Row, Col, Container, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

// services
import { api_GET, api_POST } from "../../services/api_service.js";
import { showMessage, showQuestion } from "../../services/message.js";
import { CancelarRequerimentoByProtocolo } from "../../services/requerimento_service.js";

// views
import FichaTransportador from "../Shared/Transportador/FichaTransportador";
import FichaGerador from "../Shared/Gerador/FichaGerador";
import FichaDestino from "../Shared/Destino/FichaDestino";

//Context
import { useAuth } from "../../context/auth";

export default function MeuCadastro({ history }) {
    const { session, setLoading, signIn, signOut, setupSistema } = useAuth();
    const { register, errors, setError, clearErrors, getValues } = useForm({ mode: "onBlur" });
    const [protocolo, set_protocolo] = useState(null);
    const [meuCadastro, set_MeuCadastro] = useState();
    const [itemMeuCadastro, set_itemMeuCadastro] = useState(null);

    const handleClickConsultar = () => {
        setLoading(true);
        let data = getValues();

        if (data.cpf_cnpj == "") {
            showMessage("Atenção", "Informe o CNPJ/CPF para acessar MEU CADASTRO!", 'warning', null);
            setLoading(false);
            return;
        }

        api_GET('protocolo/MeuCadastro/' + data.cpf_cnpj)
            .then(result => set_MeuCadastro(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const handleCard = (item, key) => {
        return (
            <Col key={key} lg="4" md="6" sm="6">
                <Card className="card-stats card-box">
                    <CardHeader className="text-center titulo-card">
                        {item.categoria_Descricao == "RSS" ? item.segmento.replace("Grande", "") : item.segmento}
                        <br />
                        <label>{item.categoria_Descricao}</label>
                        <div className="text-left">
                            <small>Responsável: {item.nomeResponsavel}</small><br />
                            <small>Endereço: {item.endereco}</small>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md="12" xs="12" >
                                <div className="icon-lg text-center icon-warning">
                                    <i class={item.classeIcone + " " + item.CorIcone}></i>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardFooter className="text-center">
                        <hr />
                        {item.mensagemBloqueioNovoCadastro != null &&
                            <div>
                                <Button color="gray" onClick={() => showMessage("Atenção", item.mensagemBloqueioNovoCadastro, 'warning', null)}>Atenção </Button>
                                <br />
                                <br />
                                <Button color="success" className="btn-mobile" onClick={() => { handleRecuperarRequerimento(item); }} style={{ width: "100%" }}>Recuperar Requerimento</Button>
                                <br />
                                <br />
                                <Button color="danger" className="btn-mobile" onClick={() => { handleCancelarRequerimento(item); }} style={{ width: "100%" }}>Cancelar Requerimento</Button>
                            </div>
                        }
                        {item.mensagemBloqueioNovoCadastro == null &&
                            <Button color="success" onClick={() => openModal(item)}>Acessar </Button>
                        }
                    </CardFooter>
                </Card>
            </Col>
        );
    }

    const handleCancelarRequerimento = (item) => {
        setItemCancelamento(item);
        setMotivoCancelamento("");
        setModalCancelamento(true);
    }

    const confirmarCancelamentoRequerimento = () => {
        if (motivoCancelamento.trim() === "") {
            showMessage("Atenção", "Informe o motivo do cancelamento!", 'warning', null);
            return;
        }

        showQuestion('Atenção', 'Deseja cancelar este requerimento?', 'question', function (result) {
            if (result) {
                setLoading(true);
                CancelarRequerimentoByProtocolo(itemCancelamento.protocolo_Id, { justificativaCancelamento: motivoCancelamento}, function (result) {
                    setLoading(false);
                    setModalCancelamento(false);
                    showMessage("Aviso", "Requerimento cancelado com sucesso!", 'success', function () { window.location.reload() })
                })
            }
        })
    }

    const [esqueceuSenha, set_esqueceuSenha] = useState(false);
    const [recuperarRequerimento, set_recuperarRequerimento] = useState(false);
    const [modalCancelamento, setModalCancelamento] = useState(false);
    const [motivoCancelamento, setMotivoCancelamento] = useState("");
    const [itemCancelamento, setItemCancelamento] = useState(null);

    const [modal, setModal] = useState(false);
    const openModal = (item) => {
        set_itemMeuCadastro(item);
        set_esqueceuSenha(false);
        setModal(!modal);
    }

    const loadProtocolo = (sessionData = null) => {
        let paramentros = { protocolo_Id: null, senha: null }

        if (sessionData) {
            paramentros.protocolo_Id = sessionData.protocolo_Id;
            paramentros.senha = sessionData.senha;
        } else {
            let data = getValues();
            paramentros.senha = data.senhaModal;
            paramentros.protocolo_Id = itemMeuCadastro.protocolo_Id;
        }

        set_protocolo(null);
        setLoading(true);
        api_POST("Authenticate/AutenticarUsuarioProtocolo", { protocolo_Id: paramentros.protocolo_Id, password: paramentros.senha })
            .then(responseToken => {
                setModal(false);
                if (responseToken.data?.accessToken) {
                    api_GET('protocolo/ByDocumentoProtocolo/' + paramentros.protocolo_Id)
                        .then(response => {
                            if (response.data.status == "Pendente") {
                                if (response.data.requerimento.filter(f => f.status == "Em Andamento" || f.status == "Pendente" || f.status == "Divergente").length == 0) {
                                    showMessage("Atenção", "Não foi localizado o requerimento do seu protocolo!", 'warning', null);
                                    return;
                                }
                                else {
                                    setTimeout(function () {
                                        let _requerimento = response.data.requerimento.filter(f => f.status == "Em Andamento" || f.status == "Pendente" || f.status == "Divergente")[0];
                                        history.push({ pathname: "/auth/ConsultaRequerimento", state: { protocolo: response.data, requerimento: _requerimento } });
                                    }, 500)
                                }
                            }
                            else {
                                responseToken.data.senha = paramentros.senha;
                                signIn(responseToken.data);
                                set_protocolo(response.data);
                            }
                        })
                        .catch(err => showMessage("Aviso", err.message, 'error', null))
                        .finally(() => setLoading(false))
                }
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const confirmaSenha = () => {
        let data = getValues();

        if (!data.senhaModal) {
            showMessage("Atenção", "Informe a senha para acessar MEU CADASTRO!", 'warning', null);
            return;
        }

        loadProtocolo(null);
    }

    const recuperarSenha = () => {
        clearErrors();
        let data = getValues();

        if (data.novoEmail.length == 0 || data.codigoCadastro.length == 0) {
            if (data.novoEmail.length == 0)
                setError("novoEmail", { type: "focus" }, { shouldFocus: false });
            if (data.codigoCadastro.length == 0)
                setError("codigoCadastro", { type: "focus" }, { shouldFocus: false });
            return;
        }

        let new_password = Math.random().toString(36).slice(-8);
        let json_post = {
            protocolo_Id: itemMeuCadastro.protocolo_Id,
            novaSenha: new_password,
            email: data.novoEmail,
            codigoCadastro: data.codigoCadastro
        }

        setLoading(true);
        api_POST(`protocolo/PostAtualizarSenha`, json_post)
            .then(result => showMessage("Atenção", "Uma nova senha foi enviada para seu email.", 'success', null))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const handleRecuperarRequerimento = (item) => {
        openModal(item);
        set_recuperarRequerimento(true);
    }

    const confirmarRecuperarRequerimento = () => {
        clearErrors();
        let data = getValues();

        if (data.novoEmail.length == 0) {
            if (data.novoEmail.length == 0)
                setError("novoEmail", { type: "focus" }, { shouldFocus: false });
            return;
        }

        let json_post = {
            protocolo_Id: itemMeuCadastro.protocolo_Id,
            email: data.novoEmail
        }

        setLoading(true);
        api_POST(`protocolo/PostRecuperarRequerimento`, json_post)
            .then(result => showMessage("Atenção", "Enviado o Requerimento para E-Mail informado.", 'success', null))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        if (session && session.tipoAcesso != "Protocolo") {
            signOut(false);
            window.location.reload();
        }
        if (session && (new Date(session.expiration) < new Date())) {
            signOut(false);
            window.location.reload();
        }   
        if (session && session.tipoAcesso == "Protocolo" && protocolo == null)
            loadProtocolo(session);
    }, [session]);

    return (
        <>
            <div className="content" style={{ marginTop: "50px" }}>
                {protocolo == null &&
                    <Card className="card-stats">
                        <CardBody>
                            <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                                {!meuCadastro &&
                                    <h2 className="titulo-solicitacao">Meu Cadastro {setupSistema?.identificacao}</h2>
                                }
                                {meuCadastro &&
                                    <h2 className="titulo-solicitacao">Bem-vindo</h2>
                                }
                                {meuCadastro && meuCadastro.segmentos.filter(f => f.statusProtocolo == "Ativo").length > 0 && setupSistema && setupSistema.tipoCertificadoTransportador == "Unificado" &&
                                    <div className="row">
                                        <div className="col-12 col-lg-12 col-sm-12 text-center">
                                            <h6>Clique no QRCode abaixo para extrair seu Certificado</h6>
                                            <i style={{ cursor: "pointer" }} onClick={() => window.open("/empty/CertificadoTransportadorUnificado?protocolo=" + meuCadastro.segmentos[0].numeroProtocolo, "_blank")} className="fas fa-qrcode fa-2x"></i>
                                        </div>
                                    </div>
                                }
                                <div className="formPrincipal">
                                    <Row className={"justify-content-md-center"}>
                                        {!meuCadastro &&
                                            <div style={{ width: "100%" }}>
                                                <Row className={"justify-content-md-center"}>
                                                    <Col md="6" lg="3">
                                                        <FormGroup>
                                                            <b><label>CNPJ/CPF</label></b>
                                                            <Input type="text" maxLength="14" name="cpf_cnpj" innerRef={register({ required: true })} autoComplete="off" />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4" lg="2">
                                                        <Button color="info" className="btn-mobile" type="button" onClick={() => { handleClickConsultar(); }} style={{ width: "100%" }}><i class="fas fa-search"></i> Consultar</Button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        }
                                    </Row>
                                    {meuCadastro != null && meuCadastro.segmentos.length > 0 &&
                                        <Row className={"justify-content-md-center"}>
                                            {meuCadastro.segmentos.map((item, key) => {
                                                return handleCard(item, key);
                                            })}
                                        </Row>
                                    }
                                </div>
                            </Container>
                        </CardBody>
                    </Card>
                }

                <Modal isOpen={modalCancelamento} centered toggle={() => setModalCancelamento(false)}>
                    <ModalHeader
                        close={<button className="close" onClick={() => setModalCancelamento(false)}>&times;</button>}
                        className="md-hd" style={{backgroundColor: "#fff3cd"}}>Cancelamento de Requerimento
                    </ModalHeader>
                    <ModalBody className="md-bd">
                        <Row>
                            <Col md="12">
                                <label>Informe a justificativa do cancelamento do requerimento.</label>
                            </Col>
                            <Col md="12">
                                <FormGroup>
                                    <b><label>Justificativa do Cancelamento <span className="text-danger">*</span></label></b>
                                    <Input 
                                        type="textarea" 
                                        name="motivoCancelamento" 
                                        value={motivoCancelamento}
                                        onChange={(e) => setMotivoCancelamento(e.target.value)}
                                        placeholder="Digite o motivo do cancelamento"
                                        rows="5"
                                        maxLength="300"
                                    />
                                    {motivoCancelamento.trim() === "" && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter className="md-ft">
                        <Row>
                            <Col md="12">
                                <Button color="secondary" className="btn-mobile" onClick={() => setModalCancelamento(false)}>Cancelar</Button>
                                <Button color="danger" className="btn-mobile" type="submit" onClick={() => confirmarCancelamentoRequerimento()}><i className="fas fa-check"></i> Confirmar Cancelamento</Button>
                            </Col>
                        </Row>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={modal} centered toggle={() => setModal(false)}>
                    <ModalHeader
                        close={<button className="close" onClick={() => setModal(false)}>&times;</button>}
                        className="md-hd"><i className={itemMeuCadastro && itemMeuCadastro.classeIcone}></i> Acesso de {itemMeuCadastro && itemMeuCadastro.nomeResponsavel}
                        <label className="ml-2">{itemMeuCadastro && itemMeuCadastro.categoria_Descricao}</label>
                    </ModalHeader>
                    <ModalBody className="md-bd">
                        {!esqueceuSenha && !recuperarRequerimento &&
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <b><label>Senha</label></b>
                                        <Input type="password" name="senhaModal" innerRef={register({ required: true })} defaultValue="" />
                                        <a href="#" onClick={() => set_esqueceuSenha(true)}>Esqueci a Senha</a>
                                    </FormGroup>
                                </Col>
                            </Row>
                        }
                        {esqueceuSenha &&
                            <Row>
                                <Col md="12">
                                    <label>Informe os dados abaixo para recuperar a senha de acesso para o cadastro de {itemMeuCadastro.nomeResponsavel}</label>
                                </Col>
                                <Col md="12">
                                    <FormGroup>
                                        <b><label>E-mail</label></b>
                                        <Input type="text" name="novoEmail" innerRef={register({ required: true })} autoComplete="off" />
                                        {errors.novoEmail && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup>
                                        <b><label>Código Cadastro - {setupSistema?.identificacao}</label></b>
                                        <Input type="text" name="codigoCadastro" innerRef={register({ required: true })} autoComplete="off" />
                                        {errors.codigoCadastro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <span className="text-danger">
                                        ATENÇÃO!
                                        Caso você seja Grande Gerador de Resíduo Comum (RGG), o seu Código Cadastro - SP Regula se encontra abaixo do QR-Code escaneado durante as coletas.
                                        Insira o código sem as letras e com a barra.
                                        Exemplo: 1234567/2024
                                        Para os demais resíduos como RCC e RSS favor entrar em contato com a SP-REGULA
                                    </span>
                                </Col>
                            </Row>
                        }
                        {recuperarRequerimento &&
                            <Row>
                                <Col md="12">
                                    <label>Informe E-Mail para recuperar o requerimento do cadastro de {itemMeuCadastro.nomeResponsavel}</label>
                                </Col>
                                <Col md="12">
                                    <FormGroup>
                                        <b><label>E-mail</label></b>
                                        <Input type="text" name="novoEmail" innerRef={register({ required: true })} autoComplete="off" />
                                        {errors.novoEmail && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                        }
                    </ModalBody>
                    <ModalFooter className="md-ft">
                        <Row>
                            <Col md="12">
                                <Button color="secondary" className="btn-mobile" onClick={() => setModal(false)}>Cancelar</Button>
                                {!esqueceuSenha && !recuperarRequerimento &&
                                    <Button color="success" className="btn-mobile" type="submit" onClick={() => confirmaSenha()}><i className="fas fa-check"></i>  Confirmar</Button>
                                }
                                {esqueceuSenha && !recuperarRequerimento &&
                                    <Button color="success" className="btn-mobile" type="submit" onClick={() => recuperarSenha()}><i className="fas fa-check"></i>  Confirmar</Button>
                                }
                                {!esqueceuSenha && recuperarRequerimento &&
                                    <Button color="success" className="btn-mobile" type="submit" onClick={() => confirmarRecuperarRequerimento()}><i className="fas fa-check"></i>  Confirmar</Button>
                                }
                            </Col>
                        </Row>
                    </ModalFooter>
                </Modal>

                {protocolo != null && protocolo.protocoloTransportador != null && protocolo.protocoloTransportador.length > 0 && protocolo.status !== "Pendente" &&
                    <FichaTransportador
                        item={protocolo}
                        history={history}
                        showAcoesGestor={false}
                    />
                }
                {protocolo != null && protocolo.protocoloGerador != null && protocolo.protocoloGerador.length > 0 && protocolo.status !== "Pendente" &&
                    <FichaGerador
                        item={protocolo}
                        history={history}
                        showAcoesGestor={false}
                    />
                }
                {protocolo != null && protocolo.protocoloDestino != null && protocolo.protocoloDestino.length > 0 && protocolo.status !== "Pendente" &&
                    <FichaDestino
                        item={protocolo}
                        history={history}
                        showAcoesGestor={false}
                    />
                }
            </div>
        </>
    );
}
